var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5L12.1667 12.1667M14 7.75C14 8.98613 13.6334 10.1945 12.9467 11.2223C12.2599 12.2501 11.2838 13.0512 10.1418 13.5242C8.99974 13.9973 7.74307 14.1211 6.53069 13.8799C5.31831 13.6388 4.20466 13.0435 3.33059 12.1694C2.45651 11.2953 1.86125 10.1817 1.62009 8.96931C1.37894 7.75693 1.50271 6.50027 1.97576 5.35823C2.4488 4.21619 3.24988 3.24007 4.27769 2.55331C5.3055 1.86656 6.51387 1.5 7.75 1.5C9.40761 1.5 10.9973 2.15848 12.1694 3.33058C13.3415 4.50268 14 6.0924 14 7.75Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0bb0a5207cd474e65d02383871c1e36c.svg";
export { ForwardRef as ReactComponent };